/**
* Tabbed Treatments JS
* -----------------------------------------------------------------------------
*
* All the JS for the Tabbed Treatments component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'tabbed-treatments',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.tabbed-treatments__tabs-list button' ).on( 'click', function() {
        const tab = $( this ).data( 'tab' );
        showTab( tab );
      } );

      $( '.tabbed-treatments__select' ).on( 'change', function() {
        const tab = $( this ).find( ':selected' ).data( 'tab' );
        showTab( tab );
      } );

      function showTab( tab ) {
        const component = $( '#' + tab ).closest( 'section' );
        $( component ).find( '.tabbed-treatments__tabs-list button' ).removeClass( 'is-active' );
        $( component ).find( '.tabbed-treatments__tab' ).removeClass( 'is-active' );
        $( component ).find( '.tabbed-treatments__select option[data-tab="' + tab + '"]' ).prop( 'selected', true );
        $( component ).find( '.tabbed-treatments__tabs-list button[data-tab="' + tab + '"]' ).addClass( 'is-active' );
        $( component ).find( '.tabbed-treatments__tab#' + tab ).addClass( 'is-active' );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'tabbed-treatments', COMPONENT );
} )( app );
